import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

import { addFlyout, FLYOUT_TYPES } from '@common/utils/flyout';
import DefaultSkeleton from '../../skeletons/default_skeleton';

import './checkin_checkout_cell.scss';

const CLASS_NAME = 'checkin-checkout-cell';

const onReservationClick = reservationId => () => {
  addFlyout(FLYOUT_TYPES.RESERVATION_DETAILS, {
    reservationId,
  });
};

const CheckinCheckoutCell = (props, customProps) => {
  const events = _.get(props, 'events');
  const defaultCell = _.get(customProps, 'defaultCell');
  const withSkeletons = _.get(customProps, 'withSkeletons');
  const withLink = _.get(customProps, 'withLink');

  const checkin = _.get(events, 'checkin');
  const checkout = _.get(events, 'checkout');
  const isCheckoutCell = _.get(customProps, 'checkout');

  if (withSkeletons && _.isUndefined(events)) {
    return <DefaultSkeleton />;
  }

  const isEmptyCell =
    (isCheckoutCell && _.isEmpty(_.keys(checkout))) ||
    (!isCheckoutCell && _.isEmpty(_.keys(checkin)));

  if (isEmptyCell) {
    return <div className="default-cell--empty"> - </div>;
  }

  let date = _.get(checkin, 'checkin_date');
  let id = _.get(checkin, 'id');
  let typeGuest = _.get(checkin, 'type_guest.name');

  if (isCheckoutCell) {
    date = _.get(checkout, 'checkout_date');
    id = _.get(checkout, 'id');
    typeGuest = _.get(checkout, 'type_guest.name');
  }

  const formattedDate = date && moment(date).format('MM/DD/YY');
  const content = (
    <>
      <div className={`${CLASS_NAME}__title`}>{typeGuest}</div>
      {formattedDate && <div className={`${CLASS_NAME}__date`}>{formattedDate}</div>}
    </>
  );

  if (withLink) {
    return (
      <div
        className={classnames(CLASS_NAME, `${CLASS_NAME}--link`, { 'default-cell': defaultCell })}
        onClick={onReservationClick(id)}
        role="presentation"
      >
        {content}
      </div>
    );
  }

  return <div className={classnames(CLASS_NAME, { 'default-cell': defaultCell })}>{content}</div>;
};

CheckinCheckoutCell.propTypes = {
  checkin: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  checkout: PropTypes.shape({
    name: PropTypes.string,
  }),
};

export default CheckinCheckoutCell;
